<form [formGroup]="formName">
    @if (pKeyFilter === null) {
            <input type="text" [maxLength]="field.validation.max" appUppercase pInputText [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" class="w-full" [placeholder]="placeholder" />
    } @else {
            <input type="text" appUppercase pInputText [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [pKeyFilter]="pKeyFilter" class="w-full" [placeholder]="placeholder" />
    }
</form>